import { getEnv } from '@ctct/ctct-helpers';

import type { AvailableCurrenciesResponse } from '../../repositories/payment-repo/schemas/available-currencies.zod';

export class AvailableCurrencies {
  private currencyOptions: {
    value: string;
    label: string;
    iconSrc: string;
  }[];

  private availableCurrencies: string[];

  constructor(apiResponse: AvailableCurrenciesResponse) {
    const getLabel = (currencyCode: string) => {
      if (currencyCode === 'USD') return 'USD ($)';

      if (currencyCode === 'AUD') return 'AUD (A$)';

      if (currencyCode === 'CAD') return 'CAD (CA$)';

      if (currencyCode === 'EUR') return 'EUR (€)';

      if (currencyCode === 'GBP') return 'GBP (£)';

      if (currencyCode === 'INR') return 'INR (₹)';

      if (currencyCode === 'MXN') return 'MXN (MX$)';

      if (currencyCode === 'NZD') return 'NZD (NZ$)';

      if (currencyCode === 'BRL') return 'BRL (R$)';

      return '';
    };

    const getIconSrc = (currencyCode: string) => {
      const baseURL = `https://www${getEnv()}constantcontact.com/flags/`;

      if (currencyCode === 'USD') return `${baseURL}US.svg`;

      if (currencyCode === 'AUD') return `${baseURL}AU.svg`;

      if (currencyCode === 'CAD') return `${baseURL}CA.svg`;

      if (currencyCode === 'EUR') return `${baseURL}EU.svg`;

      if (currencyCode === 'GBP') return `${baseURL}GB.svg`;

      if (currencyCode === 'INR') return `${baseURL}IN.svg`;

      if (currencyCode === 'MXN') return `${baseURL}MX.svg`;

      if (currencyCode === 'NZD') return `${baseURL}NZ.svg`;

      if (currencyCode === 'BRL') return `${baseURL}BR.svg`;

      return '';
    };

    this.availableCurrencies = apiResponse;

    this.currencyOptions = apiResponse.map((currency) => {
      return {
        value: currency,
        label: getLabel(currency),
        iconSrc: getIconSrc(currency),
      };
    });
  }

  public getAvailableCurrencies() {
    return this.availableCurrencies;
  }

  public getCurrencyOptions() {
    return this.currencyOptions;
  }
}
